import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Fire-and-forget bilingual welcome email. Never blocks or breaks signup.
export async function sendWelcomeEmail({ email, name, role, originUrl }) {
  try {
    await axios.post(`${API}/emails/welcome`, {
      email,
      name: name || "",
      role: role || "lab",
      origin_url: originUrl,
    });
  } catch {
    /* best-effort: email failures must never affect onboarding */
  }
}

// Fire-and-forget: notify active designers that a new case was published.
// Idempotent server-side (one per case); never blocks case publication.
export async function notifyNewCase(caseId, originUrl) {
  try {
    await axios.post(`${API}/notifications/new-case`, {
      case_id: caseId,
      origin_url: originUrl,
    });
  } catch {
    /* best-effort: notification failures must never affect publishing */
  }
}
